import {
  apiRequest,
  skp3kApprove,
  skp3kDetail,
} from "../../../../../services/adapters/kepegawaian/skp3kService";

class UpdateRepository {
  fetchApprove = async (query) => {
    return await apiRequest(
      "post",
      skp3kApprove,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      skp3kDetail,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
